<template>
  <zm-dialog :visible.sync="visible" class="opc-partner-offer-dialog" show-close width="890px" @close="handleCancel">
    <div ref="offerDetailTemplateRef" class="opc-partner-offer-dialog__content" v-html="offerDetailTemplate" />
  </zm-dialog>
</template>

<script>
import _ from 'lodash';
import offerDetailBg from '@/assets/partner/offer-detail-bg.svg';
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import { mapGetters } from 'vuex';
import { logger } from '@/utils/log';
import { checkPartnerMsgByCondition, getMessageTemplateByRules } from '@/views/config/partner-refer/helper/validator';
import { getPartnerRefer } from '@/views/config/partner-refer/helper/utils';
import { isEmptyVal, safeJSONParse } from '@/utils';
import { messageRuleCodeMap } from '@/views/config/partner-refer/helper/constant';

const updateElementStyle = ($element, status) => {
  $element && ($element.style.display = (status ? 'block' : 'none'));
};

export default {
  name: 'PartnerOfferDetail',
  mixins: [ConfirmComponent],
  data() {
    const offerDetailMsg = getPartnerRefer().offerDetailMsg;

    return {
      offerDetailBg,
      offerDetailTemplate: _.isArray(offerDetailMsg) ? '' : offerDetailMsg,
    };
  },
  computed: {
    ...mapGetters(['isEligibleForPartner', 'getSelectedPlans', 'partnerRefer', 'showInEligibleMsg', 'partnerReferProductNames', 'getSelectedPlansWithQuantityMap']),
  },
  methods: {
    /// todo will archive --- start
    toggleIneligiblePlanDiscountView(status) {
      const $offerDetailTemplate = this.$refs.offerDetailTemplateRef;
      const $inEligibleElement = $offerDetailTemplate?.querySelector('#partner-ineligible-discount');

      logger.info('$inEligibleElement', $inEligibleElement);

      updateElementStyle($inEligibleElement, status);
    },
    updateEligiblePlanDiscountView() {
      const { eligiblePlanList } = this.partnerRefer?.rules;
      const $offerDetailTemplate = this.$refs.offerDetailTemplateRef;
      const planCodeList = _.keys(this.getSelectedPlansWithQuantityMap);

      const updateElement = (planCode) => {
        const $currentDiscountHead = $offerDetailTemplate?.querySelector(`#${planCode}`);

        logger.info('$currentDiscountHead', $currentDiscountHead, planCodeList);

        $currentDiscountHead && updateElementStyle($currentDiscountHead, this.showInEligibleMsg ? false : _.includes(planCodeList, planCode));
      };

      return _.chain(eligiblePlanList)
        .flatten()
        .uniq()
        .forEach(updateElement)
        .value();
    },
    showAllPromotionPlans() {
      this.toggleIneligiblePlanDiscountView(this.showInEligibleMsg);
      this.updateEligiblePlanDiscountView();
    },
    replaceOfferDetailMsg() { // new template for type(string)
      const $offerDetailTemplate = this.$refs.offerDetailTemplateRef;
      const selectedPlanCodeList = _.keys(this.getSelectedPlansWithQuantityMap);
      const templateElementList = $offerDetailTemplate?.querySelectorAll('.offer-detail-msg-template');

      return _.reduce(templateElementList, (preValid, $template) => {
        const eligibleCountry = $template?.getAttribute('data-eligibleCountry');
        const eligiblePlanList = $template?.getAttribute('data-eligiblePlanList');

        if (preValid) {
          updateElementStyle($template, false);
        } else {
          const messageRuleList = [{
            ruleCode: messageRuleCodeMap.country,
            ruleValue: _.chain(eligibleCountry)
              .split(',')
              .filter((p) => !isEmptyVal(p))
              .value(),
          }, {
            ruleCode: messageRuleCodeMap.planList,
            ruleValue: _.chain(eligiblePlanList)
              .split(',')
              .filter((p) => !isEmptyVal(p))
              .map((p) => p ? safeJSONParse(p, []) : [])
              .value(),
          }];

          preValid = checkPartnerMsgByCondition(messageRuleList, {
            planCodeList: selectedPlanCodeList,
          });

          updateElementStyle($template, preValid);
        }

        return preValid;
      }, false);
    },
    // todo will archive --- end
    getOfferDetailTemplateByRules() { // new template for type(Array)
      const { offerDetailHeader, offerDetailMsg, offerDetailFooter } = this.partnerRefer || {};

      const header = getMessageTemplateByRules(offerDetailHeader)?.messageBody || "";
      const body = getMessageTemplateByRules(offerDetailMsg)?.messageBody || "";
      const footer = getMessageTemplateByRules(offerDetailFooter)?.messageBody || "";

      this.offerDetailTemplate = `${header}${body}${footer}`;
    },
    updateOfferDetailMsg() {
      const offerDetailMsg = this.partnerRefer?.offerDetailMsg || [];

      if (_.isArray(offerDetailMsg)) {
        this.getOfferDetailTemplateByRules();
      } else {
        this.replaceOfferDetailMsg(); // need config several rule into tag attribute
        this.showAllPromotionPlans();
      }
    },
  },
  watch: {
    visible: {
      handler(val) {
        const promoPartnerName = `partner promo - ${this.partnerRefer.partnerName}`;

        if (val) {
          this.$nextTick(() => this.updateOfferDetailMsg());
        }

        val ? this.$tracking.buyInteraction(
          promoPartnerName,
          `${this.partnerReferProductNames} - offer details modal - impression`,
        ) : this.$tracking.buyInteraction(
          promoPartnerName,
          `${this.partnerReferProductNames} - offer details modal - exit`,
        );
      },
    },
  },
};
</script>

<style lang="scss">
.opc-partner-offer-dialog {
  .zm-dialog {
    &__headerbtn {
      top: 15px;
      right: 13px;
      font-size: 20px;

      .zm-dialog__close {
        color: #131619 !important;
      }
    }

    &__body {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  &__title {
    font-family: 'Almaden Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 22px;
    line-height: 150%;
    color: #515079;
    margin-bottom: 25px;
  }

  &__img {
    width: 249px;
    height: 138px;
    margin-bottom: 50px;
  }

  &__content {
    margin: 0px auto;
    text-align: center;

    &--title {
      text-align: center;
      line-height: 36px;
      font-size: 24px;
      color: #00053D;
      font-family: 'Internacional', 'Helvetica', 'Arial';
      font-weight: 400;
      padding: 0px 60px;
    }

    &--subTitle {
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: 150%;
      margin-top: 12px;
      font-style: normal;
      padding: 0px 60px;
    }

    &--desc {
      text-align: center;
      margin-top: 20px;
      font-size: 12px;
      line-height: 18px;
      padding: 0px 50px;
    }
  }
}
</style>
